//@ts-nocheck
import Router from "@jack-henry/web-component-router";
import { routerConfig } from "../routers";

export const AppRouters = new Router(routerConfig);
